
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { DataPasser } from './data-passer';

@Injectable()
export class DataPasserService {

    private pass: DataPasser;
    private subject: Subject<DataPasser> = new Subject<DataPasser>();

    setData(pass: DataPasser): void {
        this.pass = pass;
        this.subject.next(pass);
    }

    getData(): Observable<DataPasser> {
        return this.subject.asObservable();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/administration-main/deployment-container/data-passer/data-passer.service.ts